import React from 'react'
import Card from './Card'

export * from './Card'
export default React.memo(Card)
